import React from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Image, Text } from 'Components/Base';

const LoginSuccessContent = () => {
  const { t } = useTranslation('registerLogin');
  return (
    <Flex
      width={1}
      flexDirection={'column'}
      alignItems={'center'}
      height="100%"
      fontFamily="'IBM Plex Sans Thai Looped', Anuphan, sans-serif"
    >
      <Image mt={3} src="/assets/images/classroom-greeting.png" />
      <Flex width={1} flexDirection={'column'} alignItems={'center'}>
        <Text mt={7} textStyle={'subtitle1'} textAlign={'center'}>
          {t('LOGIN_SUCCESS.TITLE')}
        </Text>
        <Text mt={2} textStyle={'body2'} fontWeight={'normal'} textAlign={'center'}>
          {t('LOGIN_SUCCESS.CAPTION')}
        </Text>
      </Flex>
    </Flex>
  );
};

export default LoginSuccessContent;
